export default function addTheaterModeClass() {
    const body = document.querySelector('body');
    const className = 'in-theater-mode';

    if (body && !body.classList.contains(className)) {
        body.classList.add(className);
    }
}
